import { Reducer, AnyAction } from "redux";
import { Span, startInactiveSpan } from "@sentry/react";
import { IParcelBidRequest } from "../models/parcel/IParcelBid";

export interface ISentryStoreState {
    processBidSpan: Span | undefined;
}

export type KnownAction = ISentryStartProcessBid | ISentryStopProcessBid;

export interface ISentryStartProcessBid {
    type: "SENTRY_START_PROCESS_BID";
    request: IParcelBidRequest;
}
export interface ISentryStopProcessBid {
    type: "SENTRY_STOP_PROCESS_BID";
}

export const defaultState: ISentryStoreState = {
    processBidSpan: undefined
};

export const reducer: Reducer = (
    state: ISentryStoreState | undefined,
    incomingAction: AnyAction
) => {
    const prevState = state || defaultState;
    const action = incomingAction as KnownAction;

    switch (action.type) {
        case "SENTRY_START_PROCESS_BID": {
            const processBidSpan = startInactiveSpan({
                name: "Process Bid",
                attributes: { request: incomingAction.request }
            });
            return { ...prevState, processBidSpan };
        }
        case "SENTRY_STOP_PROCESS_BID": {
            if (prevState.processBidSpan) {
                prevState.processBidSpan.end();
            }
            return { ...prevState, processBidSpan: undefined };
        }
        default:
            return { ...prevState };
    }
};
